import EmpleadoTable from "./EmpleadoTable";
import CardLayout from "../Layout/CardLayout";
import React from "react";
import CostoFijosTable from "./CostoFijosTable";

const CostosFijosMensual = (ciemId) => {

    const contributionForm =
        <CostoFijosTable optionName={"costosFijosMensualTable"}
                         ciemId={ciemId}
                        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"costosFijosMensualTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};

export default CostosFijosMensual;